export const CONSTANTS = {
	termsAndPrivacyUrl: 'https://yetisnow.com/privacy-policy/',
	connectionTroubleshootingUrl: 'https://support.yetisnow.com/account/connection-troubleshooting/',
	localStorage: {
		keys: {
			appName: 'appName',
			inactivityReminder: 'inactivityReminder',
			lastSiteIdCompleted: 'lastSiteIdCompleted',
			pushNotification: 'pushNotification',
			unreadQuantity: 'unreadQuantity',
			messages: 'messages',
			messagesModalOpened: 'messagesModalOpened',
			recentlyResumed: 'recentlyResumed',
			crew: 'crew',
			user: 'user',
			endShiftButtonVisibility: 'endShiftButtonVisibility',
			latestGeolocationKey: 'latestGeolocationKey',
			sitePerformanceDataprovider: 'sitePerformanceDataprovider',
			navigationAppPreference: 'navigationAppPreference',
			onBoardEquipment: 'onBoardEquipment',
			openPulldownTutorial: 'openPulldownTutorial',
			openSwipeleftTutorial: 'openSwipeleftTutorial',
			authToken: 'authToken', // Authentication token.
			language: 'language',
			socialLogin: 'socialLogin',
			socialRegister: 'socialRegister',
			company: 'company', // Current company
			temperatureUnit: 'temperatureUnit',
			currency: 'currency',
			lengthUnit: 'lengthUnit',
			password: 'password',
			onboard_equipment: 'onboard_equipment',
			menu: {
				companies: 'menu_companies',
				condition: 'menu_condition',
				unreadMessages: 'unreadMessages'
			},
			shiftButtonDisplayed: 'shiftButtonDisplayed',
			imageCache: 'imageCache',
			locationDisclosureAccepted: 'locationDisclosureAccepted',
			requestLocationStatus: 'requestLocationStatus',

			connectionType: 'connectionType',
			alertErrorOnVisible: 'alertErrorOnVisible',
			backgroundLocationWatcherIds: 'backgroundLocationWatcherIds',
			lastSiteByShift: 'lastSiteByShift',
			photoSetting: 'photoSetting',
			geofenceDetection: 'geofenceDetection',
			geofenceLastDetection: 'geofenceLastDetection',
			geolocation: 'geolocation',
		},
	},
};
